import { posthog } from 'posthog-js';
import type { Router } from 'vue-router';

export function setupPostHog(router: Router) {
  const { VITE_APP_POSTHOG_KEY, VITE_APP_POSTHOG_HOST } = import.meta.env;

  if (!VITE_APP_POSTHOG_KEY) {
    return;
  }

  posthog.init(VITE_APP_POSTHOG_KEY, {
    api_host: VITE_APP_POSTHOG_HOST || 'https://eu.i.posthog.com',
    person_profiles: 'identified_only',
    // No cookies/localStorage — state resets on refresh, re-identified on login
    persistence: 'memory',
    // Disabled — SPA pageviews are tracked manually via router.afterEach below
    capture_pageview: false,
    // Enables time-on-page calculation between $pageview and $pageleave
    capture_pageleave: true,
    // Disabled for GDPR — pinned off at SDK level so it can't be toggled on via dashboard
    disable_session_recording: true,
    // Restrict autocapture to meaningful interactions, skip Vuetify wrapper elements
    autocapture: {
      dom_event_allowlist: ['click', 'submit'],
      element_allowlist: ['a', 'button', 'form'],
      css_selector_allowlist: ['[data-test-id]'],
    },
  });

  // Manual SPA pageview tracking with module name for feature usage breakdown
  router.afterEach((to) => {
    const module = to.path.split('/')[1] || 'root';

    posthog.capture('$pageview', {
      $current_url: window.location.origin + to.fullPath,
      module,
    });
  });
}
